/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, func } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

const styles = (theme) => ({
    modalContainer: {
        padding: '0',
        '&:focus': {
            outline: 'none',
        },
    },
    headerModalText: {
        textAlign: 'center',
        fontWeight: '700',
        marginBottom: '15px',
    },
    btnContinue: {
        '&#btn-continue-checkout': {
            backgroundColor: theme.palette.primaryButton,
            color: theme.palette.colorPrimaryContrast,
            fontSize: '16px',
            fontWeight: 'bold',
            margin: '10px auto',
            display: 'block',
            width: '100%',
            height: 40,
            borderRadius: 24,
            '&:hover, &:focus, &:active': {
                backgroundColor: theme.palette.primaryButton,
            },
        },
    },
    btnGoHome: {
        backgroundColor: theme.palette.white,
        border: `1px solid ${theme.palette.black}`,
        color: `${theme.palette.black} !important`,
        fontSize: '16px',
        fontWeight: 'bold',
        margin: '10px auto',
        display: 'block',
        width: '100%',
        height: 40,
        padding: '7px',
        textAlign: 'center',
        borderRadius: 24,
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.white,
        },
    },
});

const ModalContent = ({ classes, closeModal }) => (
    <div className={classes.modalContainer}>
        <div className={classes.headerModalText}>Are you sure you want to leave?</div>
        <Button
            id="btn-continue-checkout"
            name="continueCheckoutButton"
            classes={{
                root: classes.btnContinue,
            }}
            color="primary"
            aria-label="NO, CONTINUE CHECKOUT"
            onClick={closeModal}
        >
            NO, CONTINUE CHECKOUT
        </Button>
        <Link
            id="btn-go-to-homepage"
            name="goToHomePageButton"
            className={classes.btnGoHome}
            aria-label="YES (GO TO HOMEPAGE)"
            to="/"
        >
            YES (GO TO HOMEPAGE)
        </Link>
    </div>
);

ModalContent.propTypes = {
    classes: object.isRequired,
    closeModal: func.isRequired,
};

export default withStyles(styles)(ModalContent);
